var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramMoneyOut48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Moneyout48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dollar",
    transform: "translate(18.000000, 17.000000)",
    stroke: "#4F4D4C",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,15.4375 L4.66910136,15.4375 M4.08333333,9.5 L2.91666667,9.5 M2.33089864,3.5625 L7,3.5625",
    id: "Arms"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91666667,3.5625 C1.30583615,3.5625 0,4.89165465 0,6.53125 C0,8.17084535 1.30583615,9.5 2.91666667,9.5 L2.91666667,9.5",
    id: "Curve"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,9.5 C5.38916948,9.5 4.08333333,10.8291546 4.08333333,12.46875 C4.08333333,14.1083454 5.38916948,15.4375 7,15.4375",
    id: "Curve-bottom",
    transform: "translate(5.541667, 12.468750) scale(-1, 1) translate(-5.541667, -12.468750) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 3.5625,
    x2: 3.5,
    y2: 0,
    id: "Stick-top"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 19,
    x2: 3.5,
    y2: 15.4375,
    id: "Stick-bottom"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Swoop",
    transform: "translate(3.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2666667,1.46666667 L18.2666667,3.46666667 C9.28283474,3.46666667 2,10.7495014 2,19.7333333 C2,28.7171653 9.28283474,36 18.2666667,36 C27.0688276,36 34.2505743,29.0039457 34.5251853,20.2534052 L34.5320938,19.9363658 L34.5333333,2.46666667 L36.5333333,2.46666667 L36.5319446,19.9607966 C36.4098715,29.9534202 28.2702384,38 18.2666667,38 C8.17826524,38 0,29.8217348 0,19.7333333 C0,9.75702525 7.99753567,1.64864171 17.9311027,1.46968706 L18.2666667,1.46666667 Z",
    id: "Path",
    fill: "#4F4C4D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "End",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFCC00",
    transform: "translate(35.533333, 3.700000) scale(1, -1) rotate(-270.000000) translate(-35.533333, -3.700000) ",
    points: "39.2333333 3.7 31.8333333 8.63333333 31.8333333 -1.23333333"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramMoneyOut48);
export default __webpack_public_path__ + "static/media/pictogramMoneyOut48.e1308bb85868787bc146f362c2ed29fe.svg";
export { ForwardRef as ReactComponent };